import { staticApi } from "src/services/api";
import { isLangAbsent, redirectWithLang } from "./utils/loader-utils";
import { STATIC_ELEMENT } from "src/constants/static";

function getElementId(urlPath) {
  switch (urlPath) {
    case "/info/terms-of-service":
      return "terms";
    case "/info/privacy-policy":
      return "privacy";
    case "/info/cancellation-policy":
      return "refunds";
    case "/info/guarantee-rules":
      return "guarantee";
    case "/about-us":
      return "about_us";
    default:
      return null;
  }
}

export async function loader({ request, params }) {
  if (isLangAbsent(request)) return redirectWithLang(request);

  const url = new URL(request.url);
  const lang = url.searchParams.get("lang");
  console.log(url.pathname);

  const elementId = getElementId(url.pathname);
  if (!elementId) return { data: {} };
  const content = await staticApi
    .getStaticFiles(window.SERVER_DATA.REACT_APP_TENANT_NAME, lang, STATIC_ELEMENT[elementId])
    .then((res) => ({ data: res }));

  return {
    content: content.data,
    display: params.id === "terms-of-service" ? "contents" : "block",
  };
}
